import React, { createContext, useState } from 'react';

export const LanguageContext = createContext();

const SUPPORTED_LANGUAGES = new Set(['en', 'fr']);

export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const toggleLanguage = () => {
    setSelectedLanguage((prevLanguage) => (prevLanguage === 'en' ? 'fr' : 'en'));
  };

  const setLanguage = (nextLanguage) => {
    if (typeof nextLanguage !== 'string' || nextLanguage.trim() === '') {
      setSelectedLanguage('en');
      return;
    }
    const normalized = nextLanguage.trim().toLowerCase();
    setSelectedLanguage(SUPPORTED_LANGUAGES.has(normalized) ? normalized : 'en');
  };

  const language = SUPPORTED_LANGUAGES.has(selectedLanguage) ? selectedLanguage : 'en';

  return (
  <LanguageContext.Provider value={{ language, selectedLanguage, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
